export default __webpack_public_path__ + "static/media/fsk-09-a.8ed54c26.jpg";